import { useState, useEffect } from 'react';

import { SMS_CONSTANTS } from '../constants';

export const usePlaceholder = (
  smsEnabled: boolean,
  recipientType: 'Account' | 'Lead',
  recipientHasPhone: () => boolean,
  loadingState: { sendingMessage: boolean },
) => {
  const [placeholder, setPlaceholder] = useState<string>(SMS_CONSTANTS.PLACEHOLDER);

  // Update placeholder when SMS enabled state changes
  useEffect(() => {
    if (recipientHasPhone()) {
      if (loadingState.sendingMessage) {
        setPlaceholder(SMS_CONSTANTS.PLACEHOLDER_SENDING);
      } else if (!smsEnabled) {
        setPlaceholder(SMS_CONSTANTS.PLACEHOLDER_UNSUBSCRIBED);
      } else {
        setPlaceholder(SMS_CONSTANTS.PLACEHOLDER);
      }
    } else {
      setPlaceholder(SMS_CONSTANTS.PLACEHOLDER_NO_PHONE);
    }
  }, [smsEnabled, recipientHasPhone, loadingState.sendingMessage]);

  return placeholder;
};
